<!-- <ng-container *ngIf="urlEncontrada else sinCA"> -->
<ng-container *ngIf="urlEncontrada && busquedaOk">
    <iframe id="FrameID" [src]="urlSafe" width="" height=""></iframe>
</ng-container>
<!-- <ng-template #sinCA *ngIf="!urlEncontrada"> -->
<ng-container  *ngIf="!urlEncontrada && busquedaOk">
    <div class="statusDiv" fxLayout="column" fxLayoutAlign="center center" [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
        <div class="roundEdg warn mat-elevation-z4 pr-20 pl-20" fxLayout="row" fxLayoutAlign="space-between center">
            <h2>{{'WIZARD.SINPRODS' | translate}}</h2>
            <mat-icon class="ml-20 s-40">error_outline</mat-icon>
        </div>
    </div>
</ng-container>
